import { createContext, useContext } from 'react';

export interface SideNavContextState {
  isNested: boolean;
}

const SideNavContext = createContext<SideNavContextState>({ isNested: false });

export const SideNavContextProvider = SideNavContext.Provider;

export const useSideNavContext = (): SideNavContextState => {
  const value = useContext(SideNavContext);
  if (!value) {
    throw new Error('useSideNavContext must be used inside a SideNavContextProvider');
  }
  return value;
};
